import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, Formatter } from 'framework-ui-components';
import { Button } from 'framework-ui-components/Components/V2';
import { visualizzaEsitiINPS } from 'apis/assegnoNucleoFamiliareApi';

class ModaleEsitiInps extends Component {
  state = {
    esiti: [],
  }

  componentDidMount() {
    const { idDichiarazione, statoDichiarazione } = this.props;

    visualizzaEsitiINPS(idDichiarazione)
      .then(x => this.setState({ esiti: x }));
  }

  render() {
    const { onClose, dichiarante, statoDichiarazione} = this.props;
    const { esiti } = this.state;

    console.log(esiti);

    return (
      <Modal show onClose={onClose}>
        <Modal.Header>Esiti invio INPS</Modal.Header>
        <Modal.Body>
          <p>Assegno nucleo familiare di {dichiarante} ({statoDichiarazione})</p>
          <Table hover>
            <Table.Head>
              <tr>
                <th>Data</th>
                <th>Descrizione esito</th>
              </tr>
            </Table.Head>
            <Table.Body>
              {
                esiti.map(z => (
                  <tr>
                    <td>
                      <Formatter tipo="date" valore={z.DataEsito} />
                    </td>
                    <td>{z.DescrizioneEsito}</td>
                  </tr>
                ))
              }
            </Table.Body>
          </Table>

        </Modal.Body>
        <Modal.Footer>
          <Button primary emphasis={Button.Emphasis.HIGH} onClick={onClose}>Chiudi</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleEsitiInps.propTypes = {
  //esiti: PropTypes.object.isRequired,
  dichiarante: PropTypes.string.isRequired,
  statoDichiarazione: PropTypes.string.isRequired,
  idDichiarazione: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModaleEsitiInps;
